import Skeleton from '@mui/material/Skeleton';
import React from 'react';

const FeedsSkelton = ({ length = 6 }) => {
  return (
    <>
      {[...Array(length)].map((item, index) => (
        <div className="feed-card  w-100 mb-5">
          <div className="p-5">
            <div
              className=" w-100 d-flex align-items-center justify-content-between "
              style={{ paddingBottom: "13px" }}
            >
              <div className="d-flex">
                <Skeleton variant="circular" width={40} height={40} className="mr-4" />
                <div>
                  <Skeleton variant="rounded" width={100} height={16} className="mb-4" />
                  <Skeleton variant="rounded" width={100} height={16} />
                </div>
              </div>
              <div className="d-flex h-100 justify-content-start">
                <Skeleton variant="rounded" width={40} height={16} />
              </div>
            </div>
            <div>
              <Skeleton variant="rounded" width={"100%"} height={16} className="mb-2" />
              <Skeleton variant="rounded" width={"100%"} height={16} />
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

export default FeedsSkelton